import styled from 'styled-components'
import { tint } from 'polished'

import { media } from 'styles/media'

export const CalendarWrapper = styled.div`
  padding: 44px 0;

  ${media.md`
    padding: 31px 12px;
  `}

  .DayPicker {
    margin: 0 auto;
    // Adding a min-height stops the calendar jumping around when navigating months
    min-height: 560px;
  }

  .CalendarDay__default {
    position: relative;

    &:focus,
    &:focus-visible {
      z-index: 1;
    }
  }

  .CalendarDay__default:active,
  .CalendarDay__default:hover {
    background: ${({ theme }) => tint(0.8, theme['-ds-core-400'].value)};
    border: 1px double ${({ theme }) => tint(0.8, theme['-ds-core-400'].value)};
  }

  .CalendarDay__blocked_calendar,
  .CalendarDay__blocked_out_of_range:active,
  .CalendarDay__blocked_out_of_range:hover {
    background: #fff;
    border-color: #e4e7e7;
  }

  .CalendarDay__blocked_calendar,
  .CalendarDay__blocked_calendar:active,
  .CalendarDay__blocked_calendar:hover {
    background: #ececec;
    border: 1px solid #ececec;
  }

  .CalendarDay__selected_span {
    background: #66e2da;
    border: 1px double #33dacd;
    border-right-style: solid; // Avoid border overlap with selected end date

    &:active,
    &:hover {
      background: #33dacd;
      border: 1px double #33dacd;
      border-right-style: solid; // Avoid border overlap with selected end date

      &.CalendarDay__blocked_calendar,
      &.CalendarDay__blocked_out_of_range {
        // Don't change appearance when hovered if blocked:
        background: #66e2da;
        border: 1px double #33dacd;
        border-right-style: solid; // Avoid border overlap with selected end date
      }
    }
  }

  .CalendarDay__selected {
    background: ${({ theme }) => theme['-ds-core-400'].value};
    border: 1px double ${({ theme }) => theme['-ds-core-400'].value};

    &:active,
    &:hover {
      background: ${({ theme }) => tint(0.1, theme['-ds-core-400'].value)};
      border: 1px double
        ${({ theme }) => tint(0.1, theme['-ds-core-400'].value)};

      &.CalendarDay__blocked_calendar,
      &.CalendarDay__blocked_out_of_range {
        // Don't change appearance when hovered if blocked:
        background: ${({ theme }) => theme['-ds-core-400'].value};
        border: 1px double ${({ theme }) => theme['-ds-core-400'].value};
      }
    }
  }
`
